export const setItem = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const getItem = (key: string) => {
  return localStorage.getItem(key) || null;
};

export const removeItem = (key: string) => {
  localStorage.removeItem(key);
};

export const reset = (preservePrefix?: string) => {
  const excludeRead = getItem('excludeRead') || 'false';

  // If prefix provided, preserve all keys starting with that prefix
  const preservedItems: Record<string, string> = {};
  if (preservePrefix) {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(preservePrefix)) {
        preservedItems[key] = localStorage.getItem(key) || '';
      }
    }
  }

  localStorage.clear();

  // Restore preserved items
  setItem('excludeRead', excludeRead);
  Object.entries(preservedItems).forEach(([key, value]) => {
    setItem(key, value);
  });
};
